import { colors, typography } from '../../../styles/theme';
import {
  APP_MODAL_TEXT,
  appModalFieldSx,
  appModalPaperSx,
  appModalPrimaryButtonSx,
} from '../../../Components/appModalChrome.styles';

/** Mismo acento que el borrar de Identidad. */
const DANGER = '#EE5757';
/** Pozo de lista: mismo fondo que Identidad (`brandsListWellSx`). */
const LIST_WELL_BG = '#141414';

export const spaceMembersPaperSx = {
  ...appModalPaperSx,
  height: { xs: 'min(640px, 85vh)', sm: 'min(680px, 82vh)' },
  maxHeight: { xs: 'min(640px, 85vh)', sm: 'min(680px, 82vh)' },
  color: APP_MODAL_TEXT,
  '& .MuiFormHelperText-root': { color: 'rgba(251,251,251,0.45)' },
  '& .MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: 'rgba(251,251,251,0.45)',
    color: 'rgba(251,251,251,0.45)',
  },
};

export const sectionLabelSx = {
  display: 'block',
  m: 0,
  mb: 1,
  flexShrink: 0,
  color: APP_MODAL_TEXT,
  fontSize: '11px',
  fontWeight: 600,
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  fontFamily: typography.fontFamily.primary,
};

export const fieldRowSx = {
  display: 'flex',
  gap: 1,
  alignItems: 'flex-start',
  flexShrink: 0,
};

export const spaceFieldSx = {
  ...appModalFieldSx,
  '& .MuiOutlinedInput-input': {
    ...appModalFieldSx['& .MuiOutlinedInput-input'],
    color: APP_MODAL_TEXT,
    WebkitTextFillColor: APP_MODAL_TEXT,
  },
  '& .MuiOutlinedInput-input.Mui-disabled': {
    WebkitTextFillColor: 'rgba(251,251,251,0.45)',
    color: 'rgba(251,251,251,0.45)',
  },
};

export const nameHelperTextProps = {
  sx: {
    m: '6px 0 0',
    color: 'rgba(251,251,251,0.45) !important',
    fontSize: '12px',
    lineHeight: 1.45,
    /** Helper de invitar en error (email escrito sin nombre guardado). */
    '&.Mui-error': { color: `${colors.error} !important` },
  },
};

/** Fila del rótulo de sección con una marca a la derecha («Requerido»). */
export const sectionLabelRowSx = {
  display: 'flex',
  alignItems: 'baseline',
  gap: 1,
  mb: 1,
  flexShrink: 0,
};

/** «Requerido»: caption sutil en gris (mismo tono que los helpers), no rojo. */
export const requiredCaptionSx = {
  m: 0,
  color: 'rgba(251,251,251,0.45)',
  fontSize: '11px',
  fontWeight: 400,
  lineHeight: 1,
  fontFamily: typography.fontFamily.primary,
};

export const inlineActionButtonSx = {
  ...appModalPrimaryButtonSx,
  flexShrink: 0,
  minWidth: 110,
  /** Mismo gris que el primario deshabilitado de compartir (`getSharePrimaryButtonSx`). */
  '&.Mui-disabled': {
    bgcolor: colors.border,
    color: '#ABABAB',
    opacity: 1,
  },
};

export const listWellSx = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  width: '100%',
  flex: 1,
  minHeight: 0,
  mt: 1.5,
  p: '8px',
  borderRadius: '8px',
  bgcolor: LIST_WELL_BG,
  boxSizing: 'border-box',
  overflowY: 'auto',
};

export const hiddenScrollbarSx = {
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
  '&::-webkit-scrollbar': { width: 0, height: 0, display: 'none' },
};

export const memberCardSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.25,
  px: '12px',
  py: '10px',
  borderRadius: '8px',
  bgcolor: colors.backgroundDark,
  minWidth: 0,
  flexShrink: 0,
};

export const memberAvatarSx = {
  width: 36,
  height: 36,
  borderRadius: '8px',
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  bgcolor: 'rgba(255,255,255,0.06)',
  color: colors.textPanelTitle,
  fontSize: '14px',
  fontWeight: 700,
  lineHeight: 1,
  fontFamily: typography.fontFamily.primary,
};

export const memberNameSx = {
  m: 0,
  fontSize: '14px',
  fontWeight: 600,
  lineHeight: '18px',
  color: APP_MODAL_TEXT,
  fontFamily: typography.fontFamily.primary,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const memberMetaSx = {
  m: 0,
  mt: 0.25,
  fontSize: '12px',
  lineHeight: '16px',
  color: 'rgba(251,251,251,0.45)',
  fontFamily: typography.fontFamily.primary,
};


export const removeButtonSx = {
  color: 'rgba(251,251,251,0.45)',
  '&:hover': { color: DANGER, bgcolor: 'rgba(238,87,87,0.12)' },
  '&.Mui-disabled': { color: 'rgba(255,255,255,0.18)' },
};

export const emptyStateSx = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  gap: 1,
  flex: 1,
  minHeight: 0,
  px: 2,
  py: 3,
};

export const skeletonSx = { bgcolor: 'rgba(255,255,255,0.08)', borderRadius: '8px' };
